import * as Yup from 'yup'

import { MEDIA_HEIGHT, MEDIA_WIDTH } from '../../../fields'

export const getInitialValues = ad => {
  return {
    [MEDIA_WIDTH]: ad.dimensions[MEDIA_WIDTH],
    [MEDIA_HEIGHT]: ad.dimensions[MEDIA_HEIGHT]
  }
}

export const validationSchema = Yup.object({
  [MEDIA_WIDTH]: Yup.number().required('Width is required'),
  [MEDIA_HEIGHT]: Yup.number().required('Height is required')
})
